import { IconButton, type IconButtonProps } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = Omit<IconButtonProps, "sx">;

export const HeaderIconButton: FC<PropsWithChildren<Props>> = ({
	children,
	...iconButtonProps
}) => {
	return (
		<IconButton
			{...iconButtonProps}
			sx={{ padding: 0 }}
			disableFocusRipple
			disableTouchRipple
		>
			{children}
		</IconButton>
	);
};
